import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";

//internal import
import DepartmentServices from "../services/DepartmentServices";
import { notifyError, notifySuccess } from "../utils/toast"; 
import { allContext } from "../context/AllContext"; 

const useDepartmentSubmit = (id) => {  
  const [viewData, setviewData] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [status, setStatus] = useState("Active");
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const { dataUpdate, setDataUpdate } = useContext(allContext);

  const {
    register,
    handleSubmit,
    setValue,
    // clearErrors,
    // reset,
    formState: { errors },
  } = useForm();
 

  const onSubmit = async (departmentData) => {
    try {
      departmentData.status = status;
      if (id) {
        const res = await DepartmentServices.updateDepartment(id, departmentData);
        notifySuccess(res.message);
        setIsModal(false);
        setDataUpdate(!dataUpdate);
      } else {
        const res = await DepartmentServices.addDepartment(departmentData);
        notifySuccess(res.message);
        setIsModal(false);
        setDataUpdate(!dataUpdate);
      } 
      return;
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };  

  const deleteDepartment = async (deptID) => {
      const result = await DepartmentServices.deleteDepartment(deptID); 
      notifySuccess(result.message);
      setIsDeleteModal(false); 
  }

  const ShowEditValues = async (row) => {  
    const result = await DepartmentServices.getDepartmentById(row._id);
    setValue("departmentName", result?.data?.departmentName);
    setStatus(result?.data?.status);   
  }

   useEffect(() => { 
    if(!id) {
      setValue("departmentName", "");  
      setValue("status", "");
      setStatus("Active");
    }
  }, [id])
 
  return {
    register,
    handleSubmit,
    onSubmit, 
    errors,
    setviewData,
    viewData,
    deleteDepartment,
    ShowEditValues,
    isModal, setIsModal,
    status, setStatus,
    isDeleteModal, setIsDeleteModal
  };
};

export default useDepartmentSubmit;
